import { useCallback } from 'react';

import FilterFieldsContext from './FilterFieldsContext';

export const SingleFieldFilterProvider = ({ children }) => {
  const getFilterFields = useCallback(
    ({ name, depends }) => [
      {
        path: name,
        ...(depends
          ? {
              dependsFields: depends.map((dependsName) => ({
                name: dependsName,
                path: dependsName,
              })),
            }
          : null),
        getPathByName: (name) => name,
        basePath: 0,
        collectionPath: 0,
      },
    ],
    []
  );

  return (
    <FilterFieldsContext.Provider value={{ getFilterFields }}>
      {children}
    </FilterFieldsContext.Provider>
  );
};
